const makeToastVariant = (color) => {
  return {
    container: {
      bgColor: 'gray.50',
      borderRadius: '8',
      maxWidth: '80',
      minHeight: '50px',
      border: 'light',
      borderColor: color,
      p: '2.5 3',
    },
    title: {
      fontWeight: 'semibold',
      fontSize: 'sm',
      color: 'black',
      lineHeight: '1.35rem',
      display: 'block',
    },
    description: {
      fontWeight: 'normal',
      fontSize: 'sm',
      color: 'black',
      lineHeight: '1.35rem',
      display: 'block',
    },
    icon: {
      h: '5',
      w: '5',
      marginInlineEnd: '3',
      color,
    },
  };
};

export default {
  Alert: {
    parts: ['container', 'title', 'description', 'icon'],
    baseStyle: {},
    sizes: {},
    variants: {
      error: {
        container: {
          bgColor: 'red.400',
          w: '100%',
          alignItems: 'start',
          borderRadius: '4px',
        },
        icon: {
          color: 'white',
        },
        description: {
          color: 'white',
        },
      },
      informative: makeToastVariant('success'), // Legacy
      positive: makeToastVariant('success'),
      negative: makeToastVariant('error'),
      neutral: makeToastVariant('notification'),
    },
    defaultProps: {},
  },
};
